import React from "react";
import { Container } from "reactstrap";
import { motion } from "framer-motion";
import "scss/css/style.css";
import "styles/loading.css";

const textVariants = {
    hidden: {
        opacity: 0,
    },
    visible: {
        opacity: 1,
        transition: {
            duration: 1,
            yoyo: Infinity, // Repite infinitamente
            ease: "easeInOut",
        },
    },
};  

const pathVariants = {
    hidden: {
        opacity: 0,
        pathLength: 0,
    },
    visible: {
        opacity: 1,
        pathLength: 1,
        transition: {
            duration: 2,
            ease: "easeInOut",
        },
    },
};  

const Loader: React.FC = () => (
    <Container
        id="loading-page"
        fluid
        className="d-flex justify-content-center align-items-center"
        style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 6,
            backgroundColor: "#4d96d8", // Color de fondo azul
            color: "#ffffff", // Color del texto negro
        }}
        initial={{ opacity: 1 }} // Asegura que la animación de entrada comienza con opacidad 1
        animate={{ opacity: 1 }} // Mantiene la opacidad en 1 durante la animación
        exit={{ opacity: 0 }} // La animación de salida hará que se desvanezca
        transition={{ duration: 1 }} // Duración más corta de la transición
    >   
    <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        height="48px"
        width="48px"
        viewBox="0 0 24 24"
        fill="none"
        initial={{ opacity: 0, pathLength: 0 }}
        animate={{ opacity: 1, pathLength: 1 }}
        transition={{ duration: 2, ease: "easeInOut" }}
        style={{
            width: "10vw", // Ajusta este tamaño si es necesario
            height: "auto",
            overflow: "visible",
        }}
    >
    <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-0.61L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27z"
        style={{
          stroke: "#ffffff", // Color del trazo negro
          strokeWidth: "2", // Asegúrate de que el trazo tenga un grosor visible
          fill: "none", // Asegúrate de que el relleno esté vacío, solo se ve el trazo
        }}
    />
    </motion.svg>
    <motion.span
        variants={textVariants}
        initial="hidden"
        animate="visible"
        style={{
            fontSize: "2rem", // Tamaño de la fuente del tema
            paddingTop: "0.5rem",
            color: "#ffffff", // Color del texto negro
        }}
        >
        Advanced Code SE
    </motion.span>
    </Container>
);

export default Loader;
